export default {
    prefs: {
        menuItemTitle: 'Set Preferences',
        dialogTitle: 'Set User Preferences',
        alarmColorsLabel: 'Alarm Colors',
        uiColorsLabel: 'UI Colors',
        graphColorsLabel: 'Graph Colors',
        colors: 'Colors',
        colorTheme: 'Color Theme',
        graphLineMarkers: 'Graph Line Markers',
        mapBillboardsToDots: 'Automatically Change Icons to Dots When Zooming',
        mapClearCacheOnExit: 'Clear Map Cache on Exit',
        mapExportIncludeLabels: 'Include Label in Map Export',
        toasterMsgTime: 'Toaster Message Display Time',
        pageRefreshInterval: 'Map Auto Refresh Interval',
        idAndNameDisplay: 'ID and Name Display',
        idAndNameOptions: {
            id: 'Display ID Only',
            name: 'Display Name Only',
            both: 'Display Both ID and Name'
        },
        graphLineMarkerOptions: {
            disable: 'Disable Line Markers',
            enable: 'Display Line Markers When Space Allows'
        },
        mapBillboardsToDotsOptions: {
            disable: 'Do Not Automatically Change',
            enable: 'Automatically Change'
        },
        clearMapCacheOnExitOptions: {
            disable: 'No',
            enable: 'Yes'
        },
        mapExportIncludeLabelsOptions: {
            disable: 'No',
            enable: 'Yes'
        },
        colorThemes: {
            NCSLight: 'Default',
            NCSLightAccessible1: 'Accessible',
            NCSDark: 'Dark'
        },
        alarmColors: {
            'alarm-critical': 'Critical',
            'alarm-major': 'Major',
            'alarm-minor': 'Minor',
            'alarm-info': 'Info',
            'alarm-unknown': 'Unknown',
            'alarm-none': 'None'
        },
        uiColors: {
            primary: 'Primary',
            secondary: 'Secondary',
            accent: 'Accent',
            error: 'Error',
            warning: 'Warning',
            info: 'Info',
            success: 'Success',
            dashletHdrBg: 'Dashboard'
        },
        units: "Units",
        duration: {
            title: 'Default Graph Duration',
            days1IntervalHourly: 'Last 24 Hours, Hourly',
            days7IntervalHourly: 'Last 7 Days, Hourly',
            days7IntervalDaily: 'Last 7 Days, Daily',
            days30IntervalHourly: 'Last 30 Days, Hourly',
            days30IntervalDaily: 'Last 30 Days, Daily',
            placeholder: 'First Available Duration'
        },
        defaultRadiosTable: 'Default Radios Table'
    }
}
